import { Box } from '@/common/components/base-app';
import { styled } from '@/stitches.config';

export const StyledSelectedRange = styled(Box, {
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
});

export const StyledDate = styled(Box, {
  marginLeft: '$4',
  fontWeight: '$bold',
  lineHeight: '$6',
});
